<template>
  <div>
    <div class="pb-5 border-gray-200 sm:flex sm:items-center sm:justify-between">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Entry Fields</h3>
        <p class="mt-2 max-w-4xl text-sm text-gray-700">These are the entry feilds that will be asked when exhibitors enter.</p>
      </div>
      <div class="mt-3 sm:ml-4 sm:mt-0">
        <button type="button" @click="addNewFieldClicked" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Add Field</button>
      </div>
    </div>
    <div v-for="(s, i) in value" :key="i">
      <ul class="divide-y divide-gray-400">
        <draggable :list="value[0].fields" @start="drag=true" @end="drag=false" handle=".handle">
          <li v-for="(f, k) in s.fields" :key="f.k" class="py-3 bg-white border-t">
            <div class="flex items-center space-x-2">
              <div tabindex="0" role="button" aria-describedby="rbd-hidden-text-0-hidden-text-0" data-rbd-drag-handle-draggable-id="2oADuscO" data-rbd-drag-handle-context-id="0" draggable="false" class="~text-gray-500 flex h-9 w-6 items-center justify-center handle draggable"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></div>
              <div class="flex-1">
                <template v-if="getFieldType(f) === 'CUSTOM'">
                  <p class="mb-1">
                    <span class="inline-flex items-center rounded-md bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800 border border-yellow-400">CUSTOM FIELD</span>
                  </p>
                  <div class="flex items-center space-x-2">
                    <div class="flex-1">
                      <div class="flex items-center space-x-2">
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Field Label</label>
                          <input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="f.label">
                        </div>
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Model</label>
                          <input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="f.model">
                        </div>
                        <div>
                          <label class="block text-xs font-medium text-gray-700  mb-1">Required</label>
                          <input v-model="f.required" class="mr-2 leading-tight" type="checkbox">
                        </div>
                        <div>
                          <label class="block text-xs font-medium text-gray-700  mb-1">Exhibitor</label>
                          <input v-model="f.exhibitor_field" class="mr-2 leading-tight" type="checkbox">
                        </div>
                        <div>
                          <label class="block text-xs font-medium text-gray-700  mb-1">Admin Only</label>
                          <input v-model="f.admin_only" class="mr-2 leading-tight" type="checkbox">
                        </div>
                        <!--<div>
                          <label class="block text-xs font-medium text-gray-700  mb-1">No Animal</label>
                          <input v-model="f.non_animal_field" class="mr-2 leading-tight" type="checkbox">
                        </div>-->
                      </div>
                      <div  class="flex items-top space-x-2">
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Hint Text (Optional)</label>
                          <input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Add some text to help out the exhibitor..." v-model="f.hint">
                        </div>
                        <div>
                          <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Field Type</label>
                            <v-select
                                class="bg-white rounded flex-1 w-56 mb-2"
                                v-model="f.selectType"
                                :options="fieldTypes"
                                label="label"
                                :reduce="option => option.value"
                                :clearable="false"
                                @input="checkInputType(f)"
                              >
                                <template #option="{ description, label }">
                                  <p class="font-medium md:text-lg">{{ label }}</p>
                                  <p class='text-xs md:text-sm whitespace-pre-wrap pb-2'>{{description}}</p>
                                </template>
                                <template #selected-option="{ label }">
                                  <div class="p-1" style="display: flex; align-items: baseline">
                                    <strong>{{ label }}</strong>
                                  </div>
                                </template>
                            </v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex space-x-2">
                      <button @click="s.fields.splice(k,1)" type="button" class="flex h-8 w-9 shrink-0 items-center justify-center text-red-600 hover:text-red-700">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
                          <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="border-l pl-16 mt-2 ml-4" v-if="f.type === 'select'">
                    <div v-for="(o, j) in f.options" :key="j">
                      <div class="flex items-center space-x-2">
                        <!--<div tabindex="0" role="button" class="~text-gray-500 flex h-9 w-6 items-center justify-center handle-o draggable"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></div>-->
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Label</label>
                          <input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="o.label">
                        </div>
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Value</label>
                          <input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="o.value">
                        </div>
                        <button @click="f.options.splice(j,1)" type="button" class="flex h-8 w-9 shrink-0 items-center justify-center text-red-600 hover:text-red-700">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
                            <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="py-3">
                      <button @click="addNewOption(f)" type="button" class="text-blue-600 flex items-center space-x-2 text-sm font-medium focus:outline-none focus:ring">
                        <div class="flex w-6 justify-center">
                          <div><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></div>
                        </div>
                        <div>Add an option</div>
                      </button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <p class="mb-1">
                    <span class="inline-flex items-center rounded-md bg-green-100 px-2 py-1 text-xs font-medium text-green-700 border border-green-400">SPECIES FIELD</span>
                  </p>
                  <div class="flex items-center space-x-2">
                    <div class="w-full flex-col flex  md:flex-row justify-between items-start">
                      <div class="w-full flex-1">
                        <div class="flex items-center space-x-2 mb-2">
                          <div class="flex-1">
                            <label class="block text-sm font-medium text-gray-700 mb-1">Field Label</label>
                            <!--<input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="f.label">-->
                            {{ f.label }}
                          </div>
                          <div class="flex-1">
                            <label class="block text-sm font-medium text-gray-700 mb-1">Field Type</label>
                            <!--<input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Field Label" v-model="f.model">-->
                            {{ fieldTypes.filter(ft => ft.value === f.selectType)[0].label }}
                          </div>
                        </div>
                        <div class="flex items-center space-x-2 mb-2">
                          <div class="flex-1">
                            <label class="block text-sm font-medium text-gray-700  mb-1">Required</label>
                            <input v-model="f.required" class="mr-2 leading-tight" type="checkbox">
                          </div>
                          <!--<div>
                            <label class="block text-xs font-medium text-gray-700  mb-1">Exhibitor</label>
                            <input v-model="f.exhibitor_field" class="mr-2 leading-tight" type="checkbox">
                          </div>-->
                          <div class="flex-1">
                            <label class="block text-sm font-medium text-gray-700  mb-1">Admin Only</label>
                            <input v-model="f.admin_only" class="mr-2 leading-tight" type="checkbox">
                          </div>
                          <!--<div>
                            <label class="block text-xs font-medium text-gray-700  mb-1">No Animal</label>
                            <input v-model="f.non_animal_field" class="mr-2 leading-tight" type="checkbox">
                          </div>-->
                        </div>
                      </div>
                      <div class="w-full md:w-1/2 flex items-top space-x-2">
                        <div class="flex-1">
                          <label class="block text-sm font-medium text-gray-700 mb-1">Hint Text (Optional)</label>
                          <!--<input type="text" class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" placeholder="Add some text to help out the exhibitor..." v-model="f.hint">-->
                          <textarea class="form-input focus-within:ring-indigo-600 focus-within:border-indigo-600" rows="3" placeholder="Add some text to help out the exhibitor..." v-model="f.hint"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="flex space-x-2">
                      <button @click="s.fields.splice(k,1)" type="button" class="flex h-8 w-9 shrink-0 items-center justify-center text-red-600 hover:text-red-700">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
                          <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div v-if="f.type === 'select'" class="flex space-x-1">
                    <p class="font-bold">Select Options:</p>
                    <div v-for="(o, j) in f.options" :key="j">
                      {{ o.label }}<span v-if="j !== f.options.length-1">,</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </draggable>
      </ul>
    </div>
    <div class="py-3">
      <button @click="addNewFieldClicked" type="button" class="text-blue-600 flex items-center space-x-2 text-sm font-medium focus:outline-none focus:ring">
        <div class="flex w-6 justify-center">
          <div><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></div>
        </div>
        <div>Add a Field</div>
      </button>
    </div>
    <b-modal ref="newField" title="New Field" hide-footer>
      <div class="mb-4">
        <p class="text-lg mb-2">What field do you want to add?</p>
        <select v-model="newFieldType">
          <option v-for="(f, i) in entryFields" :key="i" :value="f.model">{{f.label}}</option>
          <option value="CUSTOM">Add a custom field</option>
        </select>
      </div>
      <div v-if="newFieldType">
        <template v-if="newFieldType === 'CUSTOM'">
          <div class="flex space-x-2">
            <button class="btn btn-green" @click="addNewField">Add New Custom Field </button>
            <button class="btn btn-red-outline" @click="$refs.newField.hide()">Cancel</button>
          </div>
        </template>
        <template v-else>
          <div class="flex space-x-2">
            <button class="btn btn-green" @click="addNewField">Add Field - {{entryFields.filter(ef => ef.model === newFieldType)[0].label}}</button>
            <button class="btn btn-red-outline" @click="$refs.newField.hide()">Cancel</button>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    entryFields: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      drag: false,
      newFieldType: null,
      fieldTypes: [
        {
          value: 'input:text',
          label: 'Text',
          description: 'Provide a text field for exhibitors to input the info on their entry.'
        },
        {
          value: 'input:number',
          label: 'Number',
          description: 'Provide a number box for exhibtiors to input the info on their entry.'
        },
        {
          label: 'Date',
          value: 'input:date',
          description: 'Provide a date picker for exhibtiors to input the info on their entry.'
        },
        {
          value: 'checkbox',
          label: 'Checkbox',
          description: 'Provide a checbox for exhibtiors to check if applicable.'
        },
        {
          label: 'Select',
          value: 'select',
          description: 'Provide a dropdown box for exhibitors to select their answer from a list of options.'
        }
      ]
    }
  },
  watch: {
    value: function (val) {
      this.updateFieldTypes()
    }
  },
  mounted () {
    this.updateFieldTypes()
  },
  methods: {
    updateConfig () {
      this.$emit('input', this.value)
    },
    addNewFieldClicked () {
      this.$refs.newField.show()
    },
    addNewField () {
      if (!this.value[0]) {
        this.value.push({})
      }
      if (!this.value[0].fields) {
        Vue.set(this.value[0], 'fields', [])
      }
      if (this.newFieldType === 'CUSTOM') {
        this.value[0].fields.push({})
      } else {
        let field = this.entryFields.filter(ef => ef.model === this.newFieldType)[0]
        let fieldObject = {
          model: field.model,
          label: field.label
        }
        if (field.type === 'select') {
          fieldObject.type = 'select'
          fieldObject.selectType = 'select'
          fieldObject.options = field.options
        } else if (field.type === 'checkbox') {
          fieldObject.type = 'checkbox'
          fieldObject.selectType = 'checkbox'
        } else {
          fieldObject.type = 'input'
          fieldObject.selectType = `input:${field.type.toLowerCase()}`
        }
        this.checkInputType(fieldObject)
        this.value[0].fields.push(fieldObject)
      }
      this.$refs.newField.hide()
    },
    addNewOption (field) {
      if (!field.options) {
        Vue.set(field, 'options', [])
      }
      field.options.push({})
    },
    updateFieldTypes () {
      this.value.forEach(s => {
        s.fields.forEach(f => {
          if (!f.selectType) {
            if (f.type === 'select') {
              Vue.set(f, 'selectType', 'select')
            } else if (f.type === 'checkbox') {
              Vue.set(f, 'selectType', 'checkbox')
            } else {
              Vue.set(f, 'selectType', `input:${f.inputType}`)
            }
          }
        })
      })
    },
    checkInputType (field) {
      let type = field.selectType.split(':')[1]
      if (type === 'text' || type === 'date' || type === 'number') {
        field.inputType = type
        field.type = 'input'
      } else {
        field.type = field.selectType
      }
    },
    getFieldType (f) {
      if (this.entryFields.filter(ef => ef.model === f.model).length > 0) {
        return 'SPECIES'
      } else {
        return 'CUSTOM'
      }
    }
  }
}
</script>

<style>

</style>
